<script>

	import Image from './Image.svelte';
	import Text from './Text.svelte';
	import Marquee from './Marquee.svelte';
	import Video from './Video.svelte';

	/* intro {
		type: string
		background: bool|string
		color: bool|string
	} */

	export let intro;

	let templates = {
		image: Image,
		text: Text,
		marquee: Marquee,
		video: Video,
	};

</script>

{#if templates.hasOwnProperty( intro.type )}
	<aside id="intro" style="
		--background: {intro.background};
		--text-color: {intro.color};
		">
		<svelte:component this={templates[intro.type]} {...intro} />
	</aside>
{/if}

<style>

	aside {
		background-color: var(--background);
		color: var(--text-color);
	}

</style>